/** Mirrors Django `SopMode` TextChoices — which scope intake applies. */
export const SOP_MODE_ENUM = {
  FREE_FORM: 'free_form',
  LEGACY_SOP: 'legacy_sop',
  ROSETTA_VERSION: 'rosetta_version'
};

export const SOP_MODE_LABELS = {
  [SOP_MODE_ENUM.FREE_FORM]: 'Free form',
  [SOP_MODE_ENUM.LEGACY_SOP]: 'Legacy SOP',
  [SOP_MODE_ENUM.ROSETTA_VERSION]: 'Rosetta version'
};
